import React from "react";
import { useParams } from "react-router-dom";
import { JitsiMeeting } from "@jitsi/react-sdk";

const MeetingPage = () => {

    const { roomName } = useParams();

    return (
        <div style={{ height: "100vh" }}>
            <JitsiMeeting
                domain="8x8.vc"
                roomName={`vpaas-magic-cookie-6618db5905654684990d37e81d551f91/${roomName}`}
                configOverwrite={{
                    prejoinPageEnabled: false,
                    startWithAudioMuted: false,
                    startWithVideoMuted: false,
                }}
                getIFrameRef={(iframe) => {
                    iframe.style.height = "100vh";
                    iframe.style.width = "100%";
                }}
            />
        </div>
    );
};

export default MeetingPage;